import React, {
  ReactNode,
  useState,
  KeyboardEventHandler,
  useEffect
} from 'react';
import {
  getTranslatedText,
  Loader,
  SortComponent,
  NoDataCard
} from '@nile/components';
import { Tooltip } from 'react-clone-tippy';
import { Button, TextField, Checkbox } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { useIntl } from 'react-intl';
import { isEmpty } from 'lodash';
import { useGlobalState } from '@nile/components/src/Managers/StateManager';
import { savePersonalization } from '@nile/graphql';

const ListHeader = ({
  sortConstant,
  components,
  selectAll,
  toggleSelectAll,
  searchHandler,
  context,
  resetGlobalStateConditions,
  globalStateConditions,
  setGlobalStateConditions,
  setSelectedItemWrapper,
  activeView,
  user,
  getPersonalizationCategory,
  defaultSortOption,
  personalizedSort,
  module = 'ticket'
}): ReactNode => {
  const intl = useIntl();

  const [searchOpen, setSearchOpen] = useState<boolean>(
    !isEmpty(globalStateConditions?.searchConditions)
  );
  const [searchInput, setSearchInput] = useGlobalState<string | null>(
    'classicSearchVal',
    null
  );

  const handleInputChange = (val) => {
    if (val === 'Enter') {
      searchHandler(searchInput);
    } else {
      setSearchInput(val);
    }
  };
  useEffect(() => {
    setSearchOpen(!isEmpty(globalStateConditions?.searchConditions));
  }, [globalStateConditions?.searchConditions]);

  const handleKeyDown: KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (event.key === 'Enter' && searchInput) {
      searchHandler(searchInput);
    }
  };
  const resetSearch = () => {
    if (searchInput) {
      setSearchInput(null);
    }
    setSearchOpen(false);
    resetGlobalStateConditions('search');
    context?.setViewConditions(null);
  };

  const getSortTitle = (sortAttribute) => {
    if (sortAttribute) {
      const sortValue = sortConstant.find(
        (action) => action.value === sortAttribute
      );
      if (sortValue) {
        return sortValue.label;
      }
    }
    return 'kanbanview.actionlist.createdTime';
  };

  const getCloseIcon = (type) => {
    if (type === 'search') {
      if (isEmpty(globalStateConditions?.searchConditions)) {
        return <></>;
      }
    }
    if (type === 'filter') {
      if (
        isEmpty(globalStateConditions?.conditions) ||
        isEmpty(globalStateConditions?.filterConditions)
      ) {
        return <></>;
      }
    }
    return (
      <span
        role="button"
        tabIndex={0}
        onClick={() => {
          resetGlobalStateConditions(type);
        }}
        onKeyDown={() => {
          resetGlobalStateConditions(type);
        }}
        style={{
          top: '-6px',
          right: '-5px'
        }}
        className="close-icon position-absolute  ptr  br50"
      >
        <SVGIcon color="#FF9999" name="CircleCancelMinor" />
      </span>
    );
  };

  const savePersonalizationWrapper = (sortData) => {
    const personalisedData = {
      name: activeView?.id,
      category: getPersonalizationCategory,
      value: JSON.stringify(sortData),
      user: user
    };
    savePersonalization({
      variables: personalisedData,
      input: personalisedData
    });
  };

  const handleSortAction = (sortData) => {
    savePersonalizationWrapper(sortData);
    setSelectedItemWrapper(null);
    const sortValue = [sortData, ...defaultSortOption];

    setGlobalStateConditions({
      ...globalStateConditions,
      personalizedSort: sortData,
      sort: module === 'invoice' ? sortValue : sortData
    });
  };

  return (
    <div className="p5 pt0 classic-list-view-header">
      {searchOpen ? (
        <div className="mlauto animate-width" onKeyDown={handleKeyDown}>
          <TextField
            focused
            placeholder={getTranslatedText(intl, 'app.filter.search.label')}
            labelHidden
            type="text"
            variant="outline"
            value={searchInput}
            onChange={handleInputChange}
            prefix={
              <span
                className="position-relative z99 ptr"
                onClick={() => searchHandler(searchInput)}
              >
                <SVGIcon name="Search" color="gray" />
              </span>
            }
            suffix={
              <span className="position-relative z99 ptr" onClick={resetSearch}>
                <SVGIcon name="Close" color="gray" />
              </span>
            }
          />
        </div>
      ) : (
        <div className="fx fw actr pt-5 pl5">
          <Checkbox
            label=""
            checked={selectAll}
            value={selectAll}
            onChange={(val, id) => {
              toggleSelectAll(val);
            }}
          />
          <Tooltip
            title={getTranslatedText(
              intl,
              getSortTitle(personalizedSort?.attribute)
            )}
            delay={200}
            duration={250}
            position="bottom"
            inertia
            trigger="mouseenter"
            animation="shift"
            animateFill={false}
          >
            <SortComponent
              title={getSortTitle(personalizedSort?.attribute)}
              currentSortOrder={personalizedSort?.order}
              currentSortAttribute={personalizedSort?.attribute}
              defaultValue={sortConstant[0]}
              handleSortAction={handleSortAction}
              sortActionsList={sortConstant}
              isClassicView
              minWidth={!isEmpty(globalStateConditions?.filterConditions)}
            />
          </Tooltip>
          <div className="fx actr g5 mlauto position-relative">
            <Tooltip
              title=""
              delay={200}
              duration={250}
              position="bottom"
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
            >
              <span className=" position-relative">
                <components.AdvancedFilterComponent />
                {!isEmpty(globalStateConditions?.filterConditions) &&
                  getCloseIcon('filter')}
              </span>
            </Tooltip>
            <Tooltip
              title={getTranslatedText(intl, 'app.filter.search.label')}
              delay={200}
              duration={250}
              position="bottom"
              inertia
              trigger="mouseenter"
              animation="shift"
              animateFill={false}
            >
              <Button
                tertiary
                onClick={() => setSearchOpen(true)}
                icon={<SVGIcon name="Search" />}
              />
              {/* {getCloseIcon('search')} */}
            </Tooltip>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListHeader;
